import { Button, Spin } from "antd";
import { Suspense, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import { RequireAuth } from "authRoute";
import { AppLayout } from "app-layout";
import {
  // Statistics,
  AthleticsDashboard,
  Settings,
  SetPassword,
  ForgotPassword,
  Login,
  OTPVarification,
} from "pages";

import { CasesDashboard } from "pages/cases-dashboard";
import { Signup } from "pages/signup";
import { CaseInfo } from "pages/cases-detail";
import { Notes } from "pages/notes/index";
import { Emails } from "pages/emails";
import { ExcelViewer } from "pages/excel-file";

export function Routing() {
  const [authenticated, setAuthenticated] = useState(false);

  return (
    <Router>
      <AppLayout authenticated={authenticated}>
        <Suspense
          fallback={
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Spin spinning />
            </div>
          }
        >
          <Routes>
            <Route path="*" element={<NotFound />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route
              path="/reset-user-password"
              element={<div>Set password here</div>}
            />
            <Route
              path="/reset-user-email"
              element={<div>Set Email here</div>}
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/otp-verification" element={<OTPVarification />} />
            <Route
              path="/signup/otp-verification"
              element={<OTPVarification />}
            />
            <Route
              path="/"
              element={<Login setAuthenticated={setAuthenticated} />}
            />
            <Route path="/signup" element={<Signup />} />

            <Route
              path="/m2c-golf-stats"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  {/* <Statistics /> */}
                </RequireAuth>
              }
            />

            <Route
              path="/m2c-launch-stats"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  {/* <Statistics /> */}
                </RequireAuth>
              }
            />

            <Route
              path="/athletics-dashboard"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <AthleticsDashboard />
                </RequireAuth>
              }
            />

            <Route
              path="/settings"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <Settings />
                </RequireAuth>
              }
            />

            <Route
              path="/cases"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <CasesDashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/excel"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <ExcelViewer />
                </RequireAuth>
              }
            />
            <Route
              path="/emails"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <Emails />
                </RequireAuth>
              }
            />
            <Route
              path="/create-case"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <CaseInfo />
                </RequireAuth>
              }
            />
            <Route
              path="/cases/:caseId"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  <CaseInfo />
                </RequireAuth>
              }
            />

            <Route
              path="/m2c-athletics-stats"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  {/* <Statistics /> */}
                </RequireAuth>
              }
            />

            <Route
              path="/m2c-sandbox-history"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  {/* <History /> */}
                </RequireAuth>
              }
            />

            <Route
              path="/m2c-sandbox-stats"
              element={
                <RequireAuth
                  setAuthenticated={setAuthenticated}
                  authenticated={authenticated}
                >
                  {/* <Statistics /> */}
                </RequireAuth>
              }
            />
          </Routes>
        </Suspense>
      </AppLayout>
    </Router>
  );
}

function NotFound() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "20px",
        height: "100dvh",
      }}
    >
      <h1 style={{ textAlign: "center" }}>404 Page Not Found</h1>

      <Button type="primary" onClick={() => navigate("/cases")}>
        Go to Home
      </Button>
    </div>
  );
}
